import { __styles, __resetStyles, mergeClasses } from '@griffel/react';
export const listClassNames = {
  root: 'fui-List'
};
const useRootBaseStyles = /*#__PURE__*/__resetStyles("r1m6yby2", null, [".r1m6yby2{padding:0;margin:0;text-indent:0;list-style-type:none;}"]);
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__styles({
  rootHorizontal: {
    mc9l5x: "f22iagw"
  },
  rootGrid: {
    mc9l5x: "f13qh94s"
  }
}, {
  d: [".f22iagw{display:flex;}", ".f13qh94s{display:grid;}"]
});
/**
 * Apply styling to the List slots based on the state
 */
export const useListStyles_unstable = state => {
  const rootStyles = useRootBaseStyles();
  const styles = useStyles();
  const layoutToStyles = {
    ['horizontal']: styles.rootHorizontal,
    ['grid']: styles.rootGrid,
    ['vertical']: undefined
  };
  state.root.className = mergeClasses(listClassNames.root, rootStyles, layoutToStyles[state.layout], state.root.className);
  return state;
};
//# sourceMappingURL=useListStyles.styles.js.map